
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductModel } from './Entities.GormCrm.Product';
import { QuestionModel } from './Entities.GormCrm.Question';
import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireQuestionProductModel extends Model<QuestionnaireQuestionProductModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productId', type: 'guid', languageString: 'questionnaireQuestionProduct.property.productId' },
		{ name: 'questionId', type: 'guid', languageString: 'questionnaireQuestionProduct.property.questionId' },
		{ name: 'required', type: 'boolean', languageString: 'questionnaireQuestionProduct.property.required' },
		{ name: 'sortOrder', type: 'number', languageString: 'questionnaireQuestionProduct.property.sortOrder' },
		{ name: 'product', type: 'ProductModel', languageString: 'questionnaireQuestionProduct.property.product', isHidden: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'question', type: 'QuestionModel', languageString: 'questionnaireQuestionProduct.property.question', isHidden: true, isObject: true, new: () => { return new QuestionModel }, properties: () => { return QuestionModel.classProperties } }
	];
	[key: string]: any;
	
	public productId?: string;
	public questionId?: string;
	public required: boolean;
	public sortOrder: number;
	public product?: ProductModel;
	public question?: QuestionModel;
    
	constructor(){
		super();
		this.productId = undefined;
		this.questionId = undefined;
		this.required = false;
		this.sortOrder = 0;
		this.product = undefined;
		this.question = undefined;
		
	}
	getProperties(){
		return QuestionnaireQuestionProductModel.classProperties;
	}
}

